<template>
  <div>
    <div ref="wrapper" class="credit_product_wrapper" v-if="editedItem">
      <div class="page page1">
        <div class="credit_product_header">
          <table class="leftBox">
            <tr>
              <th width="55px">0%</th>
              <th width="58px">保險專案</th>
              <th width="61px">信用卡專案</th>
              <th width="">設定</th>
            </tr>
            <tr>
              <td>{{editedItem.header.caseType}}</td>
              <td>{{editedItem.header.caseType1}}</td>
              <td>{{editedItem.header.caseType2}}</td>
              <td>{{editedItem.header.caseType3}}</td>
            </tr>
          </table>
          <h1>裕隆集團&nbsp;&nbsp;&nbsp;裕富數位資融股份有限公司</h1>
          <h2>購物分期付款申請暨約定書</h2>
        </div><!--header-->
        <div class="blueBox blueBox1">
          <div class="tit">基本資料</div>
          <div class="date">
            申請日期：<span class="y">{{editedItem.applyDate.year}}</span>年
            <span class="m">{{editedItem.applyDate.month}}</span>月<span
            class="d">{{editedItem.applyDate.day}}</span>日
          </div>
          <table class="blueTable blueTable1">
            <tr>
              <th width="48px">中&nbsp;文<br/>姓&nbsp;名</th>
              <td width="115px">{{editedItem.customer.name}}</td>
              <th width="48px">身分證<br/>字&nbsp;&nbsp;&nbsp;&nbsp;號</th>
              <td>{{editedItem.customer.memberId}}</td>
            </tr>
            <tr>
              <th>出&nbsp;生<br/>日&nbsp;期</th>
              <td>
                <span>{{editedItem.customer.birthday}}</span>
                <!--<span class="y"></span>年-->
                <!--<span class="m"></span>月-->
                <!--<span class="d"></span>日-->
              </td>
              <th>婚&nbsp;姻<br/>狀&nbsp;況</th>
              <td>
                <div class="checkDiv"><span class="checkbox">
                                  <input type="checkbox" disabled
                                         v-model="editedItem.customer.married[0].value"></span>已婚
                </div>
                <div class="checkDiv"><span class="checkbox">
                                  <input type="checkbox" disabled
                                         v-model="editedItem.customer.married[1].value"></span>未婚
                </div>
                <br/>
                <div class="checkDiv"><span class="checkbox">
                                  <input type="checkbox" disabled
                                         v-model="editedItem.customer.hasChild"></span>子女<span
                  class="nb">{{editedItem.customer.childCount}}</span>人
                </div>
              </td>
            </tr>
          </table><!--blueTable1-->
          <table class="blueTable blueTable2">
            <tr>
              <th width="48px">身分證<br/>初補換</th>
              <td width="163px">
                <div class="checkDiv">
                                    <span class="checkbox">
                                      <input type="checkbox"
                                             v-model="editedItem.customer.memberIdType[0].value"
                                             disabled></span>初發<br/><span class="checkbox">
                  <input type="checkbox" v-model="editedItem.customer.memberIdType[1].value"
                                    disabled></span>補發<br/><span class="checkbox">
                  <input type="checkbox" disabled
                         v-model="editedItem.customer.memberIdType[2].value"></span>換發
                </div>
                <div class="date2">
                  <span>{{editedItem.customer.memberIdDate}}</span>
                  <!--<span class="y"></span>年-->
                  <!--<span class="m"></span>月-->
                  <!--<span class="d"></span>日-->
                </div>
              </td>
              <th width="48px">發&nbsp;證<br/>地&nbsp;點</th>
              <td v-if="checkMemberIdCityNumberType">{{getMemberIdCity(editedItem.customer.memberIdCity)}}</td>
              <td v-else>{{editedItem.customer.memberIdCity}}</td>
              
            </tr>
          </table><!--blueTable2-->
          <table class="blueTable blueTable3">
            <tr>
              <th width="48px">戶&nbsp;籍<br/>電&nbsp;話</th>
              <td width="115px" class="td-phone">
                <div class="checkDiv">
                  <span class="checkbox">
                    <input type="checkbox" v-model="editedItem.customer.hasPhone"
                                                                  disabled></span>無
                </div>
                {{editedItem.customer.phone}}
              </td>
              <th width="48px">住&nbsp;宅<br/>電&nbsp;話</th>
              <td class="td-phone">
                <div class="checkDiv">
                    <span class="checkbox"><input type="checkbox"
                                                  v-model="editedItem.customer.hasHomePhone"
                                                                  disabled></span>無
                </div>
                {{editedItem.customer.homePhone}}
              </td>
            </tr>
            <tr>
              <th>行&nbsp;動<br/>電&nbsp;話</th>
              <td class="td-phone">
                <div class="checkDiv">
                                    <span class="checkbox">
                                      <input type="checkbox"
                                             v-model="editedItem.customer.hasCellphone"
                                                                  disabled></span>無
                </div>
                {{editedItem.customer.cellphone}}
              </td>
              <th>教&nbsp;育<br/>程&nbsp;度</th>
              <td>
                <div class="checkDiv checkDiv3">
                                    <span class="checkbox"><input type="checkbox"
                                                                  v-model="editedItem.customer.educationLevel[0].value"
                                                                  disabled></span>博士
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.customer.educationLevel[1].value"
                                                disabled></span>碩士
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.customer.educationLevel[2].value"
                                                disabled></span>大學
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.customer.educationLevel[3].value"
                                                disabled></span>專科
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.customer.educationLevel[4].value"
                                                disabled></span>高中職
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.customer.educationLevel[5].value"
                                                disabled></span>其他
                </div>
              </td>
            </tr>
            <tr>
              <th>戶&nbsp;籍<br/>地&nbsp;址</th>
              <td colspan="3">{{editedItem.customer.home.residenceCity}}{{editedItem.customer.home.residenceArea}}{{ editedItem.customer.home.residenceAddress}}</td>
            </tr>
            <tr>
              <th>住&nbsp;宅<br/>地&nbsp;址</th>
              <td colspan="3" class="td-address4">
                <div class="checkDiv checkDiv4">
                                    <span class="checkbox"><input type="checkbox"
                                                                  v-model="editedItem.customer.home.homeType1[0].value"
                                                                  disabled></span>同戶籍
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.customer.home.homeType1[1].value"
                                                disabled></span>另列如下
                </div>
                {{editedItem.customer.home.homeCity}}{{editedItem.customer.home.homeArea}}{{editedItem.customer.home.homeAddress1}}
              </td>
            </tr>
            <tr>
              <th>居&nbsp;住<br/>時&nbsp;間</th>
              <td>
                <div class="date3">
                  <span class="y">{{editedItem.customer.home.liveYear}}</span>年
                  <span class="m">{{editedItem.customer.home.liveMonth}}</span>月
                </div>
              </td>
              <th>居&nbsp;住<br/>狀&nbsp;況</th>
              <td>
                <div class="checkDiv checkDiv5">
                                    <span class="checkbox"><input type="checkbox"
                                                                  v-model="editedItem.customer.home.liveLevel[0].value"
                                                                  disabled></span>本人名下
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.customer.home.liveLevel[1].value"
                                                disabled></span>配偶名下<br/>
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.customer.home.liveLevel[2].value"
                                                disabled></span>親友
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.customer.home.liveLevel[3].value"
                                                disabled></span>租賃
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.customer.home.liveLevel[4].value"
                                                disabled></span>宿舍
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.customer.home.liveLevel[5].value"
                                                disabled></span>其他
                </div>
              </td>
            </tr>
            <tr>
              <th>住&nbsp;宅<br/>地&nbsp;址</th>
              <td colspan="3" class="td-address6">
                <div class="checkDiv checkDiv6">
                                    <span class="checkbox"><input type="checkbox"
                                                                  v-model="editedItem.customer.home.homeType2[0].value"
                                                                  disabled></span>同戶籍
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.customer.home.homeType2[1].value"
                                                disabled></span>同住家
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.customer.home.homeType2[2].value"
                                                disabled></span>另列如下
                </div>
                {{editedItem.customer.home.homeAddress2}}
              </td>
            </tr>
            <tr>
              <th>E-mail</th>
              <td colspan="3" class="td-email">
                <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                    v-model="editedItem.customer.hasMail"
                                                                    disabled></span>無
                </div>
                {{editedItem.customer.email}}
              </td>
            </tr>
          </table><!--blueTable3-->
        </div><!--blueBox1-->
        <div class="blueBox blueBox2">
          <div class="tit">職業資料</div>
          <div class="contact">
            服務電話：(02)2702-5055#3<br/>
            案件傳真：(02)2700-3559
          </div>
          <table class="blueTable blueTable4">
            <tr>
              <th width="48px">公&nbsp;司<br/>名&nbsp;稱</th>
              <td width="135px" class="td-com">
                <div class="checkDiv">
                                    <span class="checkbox"><input type="checkbox"
                                                                  v-model="editedItem.company.type[0].value"
                                                                  disabled></span>無<span class="checkbox"><input
                  type="checkbox" v-model="editedItem.company.type[1].value"
                  disabled></span>家管<span class="checkbox"><input type="checkbox"
                                                                  v-model="editedItem.company.type[2].value"
                                                                  disabled></span>另列如下
                </div>
                {{editedItem.company.name}}
              </td>
              <th width="48px">公&nbsp;司<br/>電&nbsp;話</th>
              <td class="td-phone">
                <div class="checkDiv">
                                    <span class="checkbox"><input type="checkbox" v-model="editedItem.company.hasPhone"
                                                                  disabled></span>無
                </div>
                {{editedItem.company.phone}}
              </td>
            </tr>
            <tr>
              <th>公&nbsp;司<br/>地&nbsp;址</th>
              <td class="td-address" colspan="3">
                <div class="checkDiv">
                                    <span class="checkbox"><input type="checkbox"
                                                                  v-model="editedItem.company.hasAddress"
                                                                  disabled></span>無
                </div>
                {{editedItem.company.address}}
              </td>
            </tr>
          </table><!--blueTable4-->
          <table class="blueTable blueTable5">
            <tr>
              <th width="48px">職稱</th>
              <td width="90px">{{editedItem.company.title}}</td>
              <th width="35px">年資</th>
              <td width="73px">
                <div class="date4">
                  <span class="y">{{editedItem.company.workYear}}</span>年
                  <span class="m">{{editedItem.company.workMonth}}</span>月
                </div>
              </td>
              <th width="33px">月薪</th>
              <td><span class="salary">{{editedItem.company.salary}}</span>元</td>
            </tr>
          </table><!--blueTable5-->
          <div class="blueBox blueBox3">
            <div class="tit">銀行資料</div>
            <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                v-model="editedItem.bank.type[0].value"></span>沒辦過卡
            </div>
            <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                v-model="editedItem.bank.type[1].value"></span>無卡自停
            </div>
            <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                v-model="editedItem.bank.type[2].value"></span>協商繳款中
            </div>
            <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                v-model="editedItem.bank.type[3].value"></span>其他：
              <div class="others">{{editedItem.bank.otherType}}</div>
            </div>
            <table class="blueTable blueTable6">
              <tr>
                <th width="48px">發&nbsp;卡<br/>銀&nbsp;行</th>
                <td width="125px">{{editedItem.bank.name}}</td>
                <th width="50px">有&nbsp;效<br/>日&nbsp;期</th>
                <td>
                  <div class="date5">
                    <span class="m">{{editedItem.bank.effectiveYear}}</span>月
                    <span class="y">{{editedItem.bank.effectiveMonth}}</span>年
                  </div>
                </td>
              </tr>
              <tr>
                <th>卡號</th>
                <td colspan="3" class="cardNb">{{editedItem.bank.creditCard}}<span class="ps">(請填寫本人正卡資料)</span>
                </td>
              </tr>
            </table><!--blueTable6-->
          </div><!--blueBox3-->
          <div class="blueBox blueBox4">
            <div class="tit">聯絡人資料</div>
            <span class="titps">(請留一位與您不同居所的親屬，若無住家電話請留兩位聯絡人)</span>
            <table class="blueTable blueTable7">
              <tr>
                <th width="48px">中&nbsp;文<br/>姓&nbsp;名</th>
                <td width="110px">{{editedItem.firstContact.name}}</td>
                <th width="30px">關係</th>
                <td width="35px" class="text_c">{{editedItem.firstContact.type}}</td>
                <th width="50px">行&nbsp;動<br/>電&nbsp;話</th>
                <td class="td-phone">
                  <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                      v-model="editedItem.firstContact.hasCellphone"></span>無
                  </div>
                  {{editedItem.firstContact.cellphone}}
                </td>
              </tr>
            </table><!--blueTable7-->
            <table class="blueTable blueTable8">
              <tr>
                <th width="48px">住&nbsp;宅<br/>電&nbsp;話</th>
                <td width="140px" class="td-phone">
                  <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                      v-model="editedItem.firstContact.hasHomePhone"></span>無
                  </div>
                  {{editedItem.firstContact.homePhone}}
                </td>
                <th width="35px">公&nbsp;司<br/>電&nbsp;話</th>
                <td class="td-phone">
                  <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                      v-model="editedItem.firstContact.hasCompanyPhone"></span>無
                  </div>
                  {{editedItem.firstContact.companyPhone}}
                </td>
              </tr>
            </table><!--blueTable8-->
            <table class="blueTable blueTable9">
              <tr>
                <th width="48px">中&nbsp;文<br/>姓&nbsp;名</th>
                <td width="110px">{{editedItem.secondContact.name}}</td>
                <th width="30px">關係</th>
                <td width="35px" class="text_c">{{editedItem.secondContact.type}}</td>
                <th width="50px">行&nbsp;動<br/>電&nbsp;話</th>
                <td class="td-phone">
                  <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                      v-model="editedItem.secondContact.hasCellphone"></span>無
                  </div>
                  {{editedItem.secondContact.cellphone}}
                </td>
              </tr>
            </table><!--blueTable9-->
            <table class="blueTable blueTable10">
              <tr>
                <th width="48px">住&nbsp;宅<br/>電&nbsp;話</th>
                <td width="140px" class="td-phone">
                  <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                      v-model="editedItem.secondContact.hasHomePhone"></span>無
                  </div>
                  {{editedItem.secondContact.homePhone}}
                </td>
                <th width="35px">公&nbsp;司<br/>電&nbsp;話</th>
                <td class="td-phone">
                  {{editedItem.secondContact.companyPhone}}
                </td>
              </tr>
            </table><!--blueTable10-->
          </div><!--blueBox4-->
        </div><!--blueBox2-->
        <div class="redBox">
          <div class="ps">※以下欄位資料為：
            <div class="checkDiv">1.<span class="checkbox"><input type="checkbox" disabled
                                                                  v-model="editedItem.hasJointGuarantor[0].value"></span>連帶保證人(需附保證人身分證正反面影本及簽名)
            </div>
            <div class="checkDiv">2.<span class="checkbox"><input type="checkbox" disabled
                                                                  v-model="editedItem.hasJointGuarantor[1].value"></span>配偶資料僅供參考
            </div>
            <div class="checkDiv">3.<span class="checkbox"><input type="checkbox" disabled
                                                                  v-model="editedItem.hasJointGuarantor[2].value"></span>法定代理人(須於法代欄位簽名)
            </div>
            <div class="checkDiv">4.<span class="checkbox"><input type="checkbox" disabled
                                                                  v-model="editedItem.hasJointGuarantor[3].value"></span>商品實際使用人
            </div>
          </div>
          <table class="redTable">
            <tr>
              <th width="48px">姓&nbsp;名</th>
              <td width="160px">{{editedItem.jointGuarantor.name}}</td>
              <th width="55px">關&nbsp;係</th>
              <td width="83px">{{editedItem.jointGuarantor.type}}</td>
              <th width="48px">身分證<br/>字&nbsp;&nbsp;號</th>
              <td width="153px">{{editedItem.jointGuarantor.memberId}}</td>
              <th width="48px">出&nbsp;生<br/>日&nbsp;期</th>
              <td>
                <div class="date6">
                  <span>{{editedItem.jointGuarantor.birthday}}</span>
                  <!--<span class="y"></span>年-->
                  <!--<span class="m"></span>月-->
                  <!--<span class="d"></span>日-->
                </div>
              </td>
            </tr>
            <tr>
              <th>身分證<br/>初補換</th>
              <td>
                <div class="checkDiv">
                                    <span class="checkbox"><input type="checkbox"
                                                                  v-model="editedItem.jointGuarantor.memberIdType[0].value"
                                                                  disabled></span>初發<br/><span class="checkbox"><input
                  type="checkbox" v-model="editedItem.jointGuarantor.memberIdType[1].value"
                  disabled></span>補發<br/><span class="checkbox"><input type="checkbox" disabled
                                                                       v-model="editedItem.jointGuarantor.memberIdType[2].value"></span>換發
                </div>
                <div class="date7">
                  <span>{{editedItem.jointGuarantor.memberIdDate}}</span>
                  <!--<span class="y"></span>年-->
                  <!--<span class="m"></span>月-->
                  <!--<span class="d"></span>日-->
                </div>
              </td>
              <th>發&nbsp;證<br/>地&nbsp;點</th>
              <td>{{editedItem.jointGuarantor.memberIdCity}}</td>
              <th>住&nbsp;家<br/>電&nbsp;話</th>
              <td class="td-phone">
                <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                    v-model="editedItem.jointGuarantor.hasHomePhone"></span>無
                </div>
                {{editedItem.jointGuarantor.homePhone}}
              </td>
              <th>行&nbsp;動<br/>電&nbsp;話</th>
              <td class="td-phone">
                <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                    v-model="editedItem.jointGuarantor.hasCellphone"></span>無
                </div>
                {{editedItem.jointGuarantor.cellphone}}
              </td>
            </tr>
            <tr>
              <th>公&nbsp;司<br/>名&nbsp;稱</th>
              <td colspan="3">{{editedItem.jointGuarantor.companyName}}</td>
              <th>職&nbsp;稱</th>
              <td class="td-phone">
                <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                    v-model="editedItem.jointGuarantor.hasTitle"></span>無
                </div>
                {{editedItem.jointGuarantor.title}}
              </td>
              <th>公&nbsp;司<br/>電&nbsp;話</th>
              <td class="td-phone">
                <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                    v-model="editedItem.jointGuarantor.hasCompanyPhone"></span>無
                </div>
                {{editedItem.jointGuarantor.companyPhone}}
                <span class="ext">分機<span>{{editedItem.jointGuarantor.companySubPhone}}</span></span>
              </td>
            </tr>
          </table><!--redTable-->
        </div><!--redBox-->
        <div class="yBox">
          <div class="ps">
            ※以下欄位由經銷商或債權讓與人填寫並經申請人及其連帶保證人確認無誤※此案件為:「
            <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                v-model="editedItem.caseInfo.type[0].value"></span>新件
            </div>
            <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                v-model="editedItem.caseInfo.type[1].value"></span>補保人
            </div>
            <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                v-model="editedItem.caseInfo.type[2].value"></span>補資料
            </div>
            」「
            <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                v-model="editedItem.caseInfo.interestRate[0].value"></span>零利率
            </div>
            <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                v-model="editedItem.caseInfo.interestRate[1].value"></span>低利率
            </div>
            」「
            <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                v-model="editedItem.caseInfo.category[0].value"></span>ㄧ般件
            </div>
            <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                v-model="editedItem.caseInfo.category[1].value"></span>保密件
            </div>
            」
          </div>
          <div class="tit">經&nbsp;&nbsp;銷&nbsp;&nbsp;商&nbsp;&nbsp;填&nbsp;&nbsp;寫&nbsp;&nbsp;欄</div>
          <table class="yTable1">
            <tr class="yTr">
              <th width="20px" rowspan="2">分期內容</th>
              <th width="110px">商品名稱</th>
              <th width="73px" class="psTh1">頭款<span>(訂金)</span></th>
              <th width="65px">商品總價</th>
              <th width="155px" class="psTh2">辦理分期金額<span>(商品總價-已付頭款)</span></th>
              <th width="45px">期數</th>
              <th width="130px" class="psTh3">每期應繳金額<span>(期付款)</span></th>
              <th class="psTh4">分期總額<span>(期數X期付金額)</span></th>
            </tr>
            <tr>
              <td>{{editedItem.vendor.productName}}</td>
              <td>{{editedItem.vendor.deposit}}</td>
              <td>{{editedItem.vendor.totalPrice}}</td>
              <td>{{editedItem.vendor.creditPrice}}</td>
              <td>{{editedItem.vendor.installmentsNumber}}</td>
              <td>{{editedItem.vendor.creditPriceMonth}}</td>
              <td>{{editedItem.vendor.totalCreditPrice}}</td>
            </tr>
          </table><!--yTable1-->
          <table class="yTable2">
            <tr>
              <th width="70px">
                <span class="th1">經銷商或<br/>債權讓與人名稱<br/>(約定受款方)</span></th>
              <td width="133px">{{editedItem.vendor.vendorName}}</td>
              <th width="65px">
                <span class="th2">經銷商或<br/>債權讓與人<br/>電話</span>
              </th>
              <td width="105px" class="td-phone">
                <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                    v-model="editedItem.vendor.hasCellphone"></span>無電話請打手機聯絡
                </div>
                {{editedItem.vendor.cellphone}}
              </td>
              <th width="50px">
                <span class="th3">經銷商或<br/>債權讓與人<br/>傳真</span>
              </th>
              <td width="110px" class="td-phone">
                <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                    v-model="editedItem.vendor.hasFax"></span>無傳真請電話通知
                </div>
                {{editedItem.vendor.fax}}
              </td>
              <th rowspan="3" class="sign1">
                <span class="bg"></span>
                <span class="txt">(請蓋公司大小章或發票章)</span>
                <span class="ps">※債權轉讓確認章<br/>※遲延利息及委約金之請求權同意一併讓與受讓人</span>
              </th>
            </tr>
            <tr>
              <th>經辦店名稱</th>
              <td class="td-phone">
                <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                    v-model="editedItem.vendor.sameVendor"></span>同經銷商或債權讓與人
                </div>
                {{editedItem.vendor.salesName}}
              </td>
              <th>經辦店<br/>電&nbsp;&nbsp;話</th>
              <td class="td-phone">
                <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                    v-model="editedItem.vendor.hasSalesPhone"></span>無電話請打手機聯絡
                </div>
                {{editedItem.vendor.salesPhone}}
              </td>
              <th>經辦人<br/>手&nbsp;&nbsp;機</th>
              <td>{{editedItem.vendor.salesCellphone}}</td>
            </tr>
            <tr>
              <td colspan="6" class="td-phone td-phone2">

                <div class="checkDiv checkDiv2">
                  經銷商備註欄：<br/>
                  <span class="checkbox"><input type="checkbox" disabled
                                                v-model="editedItem.vendor.type[0].value"></span>熟客&nbsp;
                  <span class="checkbox"><input type="checkbox" disabled
                                                v-model="editedItem.vendor.type[1].value"></span>過路客&nbsp;
                  <span class="checkbox"><input type="checkbox" disabled
                                                v-model="editedItem.vendor.type[2].value"></span>指定照會時間：<span
                  class="m">{{editedItem.vendor.checkTime.month}}</span>月<span class="d">{{editedItem.vendor.checkTime.day}}</span>日<span
                  class="t">上</span>午<span
                  class="h">{{editedItem.vendor.checkTime.hour}}</span>點<span class="min">{{editedItem.vendor.checkTime.minute}}</span>分
                </div>
                <span class="ps2">{{editedItem.vendor.comment}}</span>
                <div class="sign2">
                  經辦人簽名
                  <span class="bg">{{editedItem.vendor.signature}}</span>
                  <span class="txt">本人證實申請人及連帶保證人身分正確並親自簽章無誤</span>
                </div>
              </td>
            </tr>
          </table><!--yTable2-->
        </div><!--yBox-->
        <div class="gTit">約定事項</div>
        <div class="gContent">
          <ul class="gBoxCon">
            申請人（以下簡稱甲方）及其連帶保證人、經銷商或債權讓與人（以下簡稱乙方）及債權受讓人裕富數位資融（股）公司（以下簡稱裕富公司）三方同意訂定本購物分期付款申請暨約定書（以下簡稱本約定書），<span
            class="redHighlight">其個別商議及特別授權之約定事項如下：</span><br/>
            <li>
              甲方及其連帶保證人同意裕富公司得將甲方及其連帶保證人與裕富公司往來本契約之相關資料（包括但不限於基本資料、信用資料、財務資料等），提供予財團法人金融聯合徵信中心依其設立目的、章程及相關法令規定，蒐集、處理及利用甲方及其連帶保證人之資料，並已暸解及同意裕富公司及財團法人金融聯合徵信中心依個人資料保護法規定所告知之事項。財團法人金融聯合徵信中心依其設立目的、章程及相關法令規定，得將本人資料提供與其參與徵信資料交換及利用之會員、融資租賃業、金融目的事業主管機關及其他依法令得蒐集、處理及利用資料之人。甲方及其連帶保證人確認已受個人資料保護法第三條及第八條告知且留存本約定書正反面繕本，得憑之主張相關權利。
            </li>
            <li>
              甲方及其連帶保證人同意裕富公司得於履行契約及商品推廣、市場調查、數據分析之目的範圍內，依個人資料保護法相關規定以電腦蒐集、處理、利用甲方及其連帶保證人提供之前述基本資料（不包括財團法人金融聯合徵信中心查詢之信用資料），並向相關之個人、機關、法人等查詢該等資料及往來紀錄，亦同意裕富公司得將前述往來之資料，提供予（一）受讓（或擬受讓）裕富公司債權之債權人，（二）受裕富公司委任代為處理事務之人或與裕富公司有簽約之委外合作廠商，（三）裕富公司之分公司，（四）裕隆汽車製造（股）公司及其相關企業／裕融企業及其關係企業，（五）財團法人金融聯合徵信中心，（六）逾期催收之受託公司（限甲方及其連帶保證人違約時）。但甲方及其連帶保證人得隨時要求停止對其相關資料交互運用。<span
              class="redHighlight">申請人就本項約定：<div class="checkDiv"><span class="checkbox"><input
              type="checkbox" v-model="editedItem.agree[0].value" disabled></span>同意</div><div class="checkDiv"><span
              class="checkbox"><input type="checkbox" v-model="editedItem.agree[1].value" disabled></span>不同意</div>（若未勾選視為不同意本契約之服務）；連帶保證人就本項約定：<div
              class="checkDiv"><span class="checkbox"><input type="checkbox" v-model="editedItem.agree[2].value"
                                                             disabled></span>同意</div><div
              class="checkDiv"><span class="checkbox"><input type="checkbox" v-model="editedItem.agree[3].value"
                                                             disabled></span>不同意</div>（若未勾選視為不同意本契約之服務）</span>
            </li>
            <li>
              甲方及其連帶保人已受說明／告知本約定書重要內容及相關權利義務，並已充分暸解本約定書之重要內容及相關權利義務，且同意乙方或裕富公司得修正本約定書正反面所填資料，並同意申請時所提供之資料及本約定書正本不予退還。
            </li>
            <li>甲方及其連帶保證人已攜回本約定書審閱，並經給予三日以上之期間詳閱並充分了解本契約之全部條款後簽訂本約定書。</li>
            <li>
              甲方及其連帶保證人於簽約時已充分暸解並同意，乙方將請求支付分期價款之權利及依「本約定書」及「指示付款同意暨約定書」約定所得享受之其他一切權利及利益（含延遲利息及違約金）讓予裕富公司，裕富公司並依約分次付款予乙方或撥入「指示付款同意暨約定書」所指定之帳戶以為收買應收帳款之債權。甲方及其連帶保證人於簽約時已充分暸解並同意，甲方於收受買賣標的物或可隨時接受服務時即為知悉債權讓與事實，並應依約繳款予裕富公司。
            </li>
            <li>商品總價以本約定書經銷商填寫欄之「商品總價金額」加上指示付款同意暨約定書之「商品改裝、整備暨附屬品價金金額」為據。</li>
            <li>
              分期價金支付還款方式與內容：（一）就本約定書所載之商品總價部分，甲方應依本約定書之經銷商填寫欄之內容按期支付還款。本分期依年金計法計算，按月平均攤還本息。（二）就「指示付款同意暨約定書」所載之改裝、裝備暨附屬品之商品價金部分，甲方應依「指示付款同意暨約定書」之約定按期支付還款。
            </li>
            <li>
              甲方及其連帶保證人同意特別授權如下：（一）甲方及其連帶保證人同意裕富公司於給付款項予乙方時，授權裕富公司及其指定人填載本票發票日（即付款日）及本票金額（即實際應繳總額），絕無異議。（二）甲方及其連帶保證人倘有違反「本約定書」及「指示付款同意暨約定書」任一條款或延遲繳款時，甲方及其連帶保證人授權裕富公司及其指定人得不經過通知逕行填載本票到期日，並主張票據權利。（三）如有附約，以雙方書面議定為主，取代口頭約定，並經甲方及其連帶保證人同意簽署。</br>
              <span class="redHighlight">※甲方、甲方之法定代理人及甲方之連帶保證人確認已充分詳閱及了解並同意本約定書及其個別商議及特別授權之約定事項各款內容並確認簽章：</span>
            </li>
          </ul>
        </div><!--gContent-->
        <div class="signBlue">
          <span class="s">(申請人)</span><br/>
          甲方簽名
          <img class="box" v-if="signImageSrc('signImage1')" :src="signImageSrc('signImage1')"/>
          <span class="box" v-else></span>
        </div>
        <div class="signGreen">
          甲方連帶保<br/>
          證&nbsp;人&nbsp;簽&nbsp;章
          <img class="box" v-if="signImageSrc('signImage3')" :src="signImageSrc('signImage3')"/>
          <span class="box" v-else></span>
        </div>
        <div class="signRed">
          甲方法定代<br/>
          理&nbsp;人&nbsp;簽&nbsp;名
          <span class="box"></span>
        </div>
        <div class="dot"><span>(續背面)</span></div>
        <div class="bottomTit">&#9826本票</div>
        <div class="bottomCon">
          憑票於中華民國<span class="d1">{{editedItem.promisedNote.promisedDate.year}}</span>年<span class="d1">{{editedItem.promisedNote.promisedDate.month}}</span>月<span
          class="d1">{{editedItem.promisedNote.promisedDate.day}}</span>日無條件支付裕富數位資融股份有限公司<br/>
          新台幣<span class="money">{{editedItem.promisedNote.money.one}}</span>拾<span class="money">{{editedItem.promisedNote.money.two}}</span>萬<span
          class="money">{{editedItem.promisedNote.money.three}}</span>仟<span class="money">{{editedItem.promisedNote.money.four}}</span>佰<span
          class="money">{{editedItem.promisedNote.money.five}}</span>拾<span class="money">{{editedItem.promisedNote.money.six}}</span>元整<span
          class="ps3">(本票金額可填大寫或阿拉伯數字，二擇一)</span>
          <span class="ps1">此本票免除做成拒絕證書及票據法第八十九條之通知義務，利息自到期日迄清償日止按年息百分之二十計付，發票人授權持票人得填載到期日。</span>
          <br/>
          付款地：{{editedItem.promisedNote.paymentCity}}<br/>
          中華民國<span class="d2">{{editedItem.promisedNote.createDate.year}}</span>年
          <span class="d2">{{editedItem.promisedNote.createDate.month}}</span>月<span
          class="d2">{{editedItem.promisedNote.createDate.day}}</span>日1.發票人：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <img class="box1" style="border: transparent 1px;" v-if="signImageSrc('signImage2')" :src="signImageSrc('signImage2')"/>
          <span class="box1" v-else></span>
          2.發票人：<img class="box2" v-if="signImageSrc('signImage3')" :src="signImageSrc('signImage3')"/>
          <span class="box2" v-else></span>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          3.發票人：<span class="box3"></span><br/>
          <span class="ps2">「此本票供為分期付款買賣之分期款項總項憑證，俟分期付款完全清償完畢時，此本票自動失效，但如有一期未付，發票人就全部本票債務負責清償」</span>

        </div><!--bottomCon-->
      </div><!--page1-->

      <v-app v-if="editedItem.imageList && editedItem.imageList.length">

        <div class="photo_page_wrapper" v-if="editedItem.imageList">
          <div class="page">
            <v-layout md12 row wrap>
              <v-flex md6 mt-2 v-for="(image, i) in getImageList" :key="i">
                <div class="box"><img :src="image.data"></div>
              </v-flex>
            </v-layout>
            <!--<div class="nb mt-2">業務姓名：{{editedItem.parentAgent.displayName}}<br/>業務電話：{{editedItem.parentAgent.cellphone}}</div>-->
          </div><!--page-->
        </div><!--wrapper-->

        <div class="photo_page_wrapper"
             v-if="editedItem.imageList && editedItem.imageList.length >= 6">
          <div class="page">
            <v-layout md12 row wrap>
              <v-flex md6 mt-2 v-for="(image, i) in getImageList2"
                      :key="i">
                <div class="box"><img :src="image.data"></div>
              </v-flex>
            </v-layout>
            <!--<div class="nb mt-2">業務姓名：{{editedItem.parentAgent.displayName}}<br/>業務電話：{{editedItem.parentAgent.cellphone}}</div>-->
          </div><!--page-->
        </div><!--wrapper-->

        <div class="photo_page_wrapper"
             v-if="editedItem.imageList && editedItem.imageList.length > 12">
          <div class="page">
            <v-layout md12 row wrap>
              <v-flex md6 mt-2 v-for="(image, i) in getImageList3"
                      :key="i">
                <div class="box"><img :src="image.data"></div>
              </v-flex>
            </v-layout>
            <!--<div class="nb mt-2">業務姓名：{{editedItem.parentAgent.displayName}}<br/>業務電話：{{editedItem.parentAgent.cellphone}}</div>-->
          </div><!--page-->
        </div><!--wrapper-->
      </v-app>

    </div><!--wrapper-->
    <div style="margin:0 auto; display:flex; align-items:center; justify-content:center;">
      <v-btn color="primary" dark text @click="confirmEvent">下載PDF檔</v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'CreditProductView',
  props: {
    item: Object,
  },
  data() {
    return {
      // item: null,
    };
  },
  created() {
    // const caseId = this.$route.query.caseId;
    // if (caseId){
    //     this.fetchFinanceCreditInfo({caseId: caseId}).then(results=>{
    //         if (results.length){
    //             this.item = results[0];
    //             console.log(`fetchFinanceCreditInfo ${JSON.stringify(this.item)}`);
    //         }
    //     });
    // }
  },
  computed: {
    ...mapGetters(['getUserInfo']),
    editedItem() {
      return this.item;
    },
    getImageList() {
      const list = [];
      this.editedItem.imageList.forEach((item, i) => {
        if (i < 6) {
          list.push(item);
        }
      });
      return list;
    },
    getImageList2() {
      const list = [];
      this.editedItem.imageList.forEach((item, i) => {
        if (i >= 6 && i < 12) {
          list.push(item);
        }
      });
      return list;
    },
    getImageList3() {
      const list = [];
      this.editedItem.imageList.forEach((item, i) => {
        if (i >= 12) {
          list.push(item);
        }
      });
      return list;
    },
    checkMemberIdCityNumberType() {
      if(this.editedItem) {
        const parsed = parseInt(this.editedItem.customer.memberIdCity, 10);        
        console.log(`checkMemberIdCityNumberType ${parsed}`)
        return !isNaN(parsed)
      } else {
        return false;
      }
    }
  },
  methods: {
    ...mapActions(['fetchFinanceCreditInfo']),
    signImageSrc(itemPath){
      let source = null;
      if (itemPath === 'signImage1'){
        if (this.editedItem.signImage1) {
          source = this.editedItem.signImage1;
        } else if(this.editedItem.signimage1Url) {
          source = this.editedItem.signimage1Url;
        }
      } else if(itemPath === 'signImage2'){
        if (this.editedItem.signImage2){
          source = this.editedItem.signImage2;
        } else if(this.editedItem.signimage2Url) {
          source = this.editedItem.signimage2Url;
        }
      } else if(itemPath === 'signImage3'){
        if (this.editedItem.signImage3){
          source = this.editedItem.signImage3;
        } else if(this.editedItem.signimage3Url) {
          source = this.editedItem.signimage3Url;
        }
      }
      return source;
    },
    confirmEvent() {
      const node = this.$refs.wrapper;      
      console.log(`node === ${node}`)
      this.$emit('ConvertPdfEvent', [node]);      
    },
    getMemberIdCity(value) {
      console.log(`getMemberIdCity ${value}`)
      const memberIdCitylist = this.getMemberIdCityList.filter(m=>m.key === value);
      if (memberIdCitylist.length > 0 ) {
        return memberIdCitylist[0].value;
      }
      return ""
    },
  },
};
</script>

<style scoped src="../../assets/css/credit_product_view.css">

</style>

<style scoped>
table.leftBox td,
.blueBox1 .date .y, .blueBox1 .date .m, .blueBox1 .date .d,
table.blueTable td,
.blueBox3 .others,
table.blueTable5 .date4 .y,
table.blueTable5 .date4 .m,
table.blueTable6 .date5 .y,
table.blueTable6 .date5 .m,
table.redTable td,
table.redTable .date7 .y,
table.redTable .date7 .m,
table.redTable .date7 .d,
table.redTable td.td-phone .ext span,
table.yTable1 td,
table.yTable2 td,
table.yTable2 td.td-phone2 .sign2 span.bg,
table.yTable2 td.td-phone2 .checkDiv2 .m,
table.yTable2 td.td-phone2 .checkDiv2 .d,
table.yTable2 td.td-phone2 .checkDiv2 .t,
table.yTable2 td.td-phone2 .checkDiv2 .h,
table.yTable2 td.td-phone2 .checkDiv2 .min,
.gContent span.txtBox,
.bottomCon .d1,
.bottomCon .money,
.bottomCon .d2
{ color:#0505da;}

table.blueTable5 .date4,
table.blueTable6 .date5,
table.redTable .date7,
table.redTable td.td-phone .ext,
table.yTable2 td.td-phone2 .sign2,
table.blueTable6 .cardNb .ps,
div.checkDiv { color:#000;}
</style>



// WEBPACK FOOTER //
// src/pages/web/CreditProductView.vue